<template>
  <!-- Modal pour le redoublement -->
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="card">
        <div class="modal-header border-0 mb-2">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <!-- Contenu initial du modal -->

        <div v-if="!isConfirmed" class="modal-body pb-4">
          <div class="mb-3 text-center mt-n3">
            <i class="fas fa-graduation-cap text-success me-2 fs-2"></i>
            <h5
              class="modal-title mt-3 fw-bold d-flex mx-auto"
              id="repeatClassModalLabel"
              style="width: max-content"
            >
              {{ $t("studentlist.confirm_next_class") }}
              <div class="mx-1 border-bottom border-success" id="span-number">
                {{ registrationNumbers.length }}
              </div>
              {{ $t("studentlist.students1") }}
            </h5>
          </div>
          <div class="content mt-n2 w-80 text-center mx-auto">
            <p style="font-size: 15px">
              {{ $t("studentlist.next_class_info") }}
            </p>
          </div>
          <form class="mx-auto w-80 mt-5" @submit.prevent="sendAlert">
            <div class="mb-3 text-start">
              <label for="matieres" style="font-size: 13px" class="form-label">
                {{ $t("studentlist.next_class_label") }}
                <em style="color: #f60000">*</em>
              </label>
              <ClassDropdown
                :items="allClassrooms"
                :selected="selectedClassObj"
                :placeholder="$t('studentlist.label_select_class')"
                dropdown-id="dropdownMenuButton"
                @select="selectClass"
              />
            </div>
          </form>
        </div>

        <!-- Message de succès après confirmation -->
        <div v-else class="modal-body pb-4">
          <div class="mb-3 text-center">
            <i class="fas fa-check-circle text-success me-2 fs-1"></i>
            <h5 class="modal-title mt-3 fw-bold text-center">
              {{ $t("studentlist.promotion_success") }}
            </h5>
          </div>

          <div class="content mt-n2 mb-5 w-70 text-center mx-auto">
            <p class="">
              {{ registrationNumbers.length }}
              {{ $t("studentlist.students_promotion_success") }}
            </p>
          </div>

          <div class="d-flex directions mx-auto">
            <argon-button
              type="button"
              class="btn"
              :title="$t('button.title_current_class')"
              data-bs-dismiss="modal"
              @click="annuler"
              style="
                width: 200px;
                height: 50px;
                padding-top: 14px;
                background: none;
                border: 1px solid rgba(255, 255, 255, 0.4);
              "
            >
              <span>{{ $t("button.stay_in") }} {{ getCurrentClassName() }}</span>
            </argon-button>

            <argon-button
              type="button"
              class="btn"
              :title="$t('button.title_promote_class')"
              @click="route"
              style="
                width: 200px;
                height: 50px;
                padding-top: 14px;
                background: none;
                border: 1px solid rgba(255, 255, 255, 0.4);
              "
            >
              <span> {{ $t("button.go_to") }} {{ getPromotedClassName() }}</span>
            </argon-button>
          </div>
        </div>

        <div class="modal-footer border-0 pe-5 pb-5 mb-1">
          <argon-button
            v-if="!isConfirmed"
            type="button"
            class="btn"
            :title="$t('button.close')"
            data-bs-dismiss="modal"
            @click="annuler"
            style="
              width: 200px;
              height: 50px;
              padding-top: 15px;
              background: none;
              border: 1px solid rgba(255, 255, 255, 0.4);
            "
          >
            <span>{{ $t("button.cancel") }}</span>
          </argon-button>

          <argon-button
            v-if="!isConfirmed"
            @click="PromoteStudent"
            type="button"
            class="btn"
            color="success"
            variant="gradient"
            style="
              width: 200px;
              height: 50px;
              padding-top: 15px;
              margin-right: 63px;
            "
            :loading="loading"
            :active="buttonActive || showConfirmation"
            :clickEvent="button"
          >
            <span v-if="!loading"> {{ $t("button.confirm") }}</span>
          </argon-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton";
import { getGrades, PromoteStudent, getSpeciality } from "@/utils/services";
import ClassDropdown from "@/components/ClassDropdown.vue";
import config from "@/config.js";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "Promote-Next",
  data() {
    return {
      showModal: false,
      loading: false,
      buttonActive: false,
      showConfirmation: false,
      selectedClass: "default",
      has_class: false,
      schoolList: [],
      allClassrooms: [],
      formSubmitted: false,
      isConfirmed: false,
      promote: config.PROMOTE,
      selectedClassObj: null,
    };
  },
  props: {
    registrationNumbers: {
      type: Array,
      required: true,
      default: () => [],
    },
    classroomId: {
      type: String,
      required: true,
    },
  },
  async created() {
    try {
      this.loading = true;
      let response = await getGrades();
      this.schoolList = response.data;

      // Trouver le niveau actuel de l'élève
      const currentGrade = this.schoolList.find(grade => 
        grade.classrooms && grade.classrooms.some(classroom => classroom.id === this.classroomId)
      );

      const currentOrderOfAppearance = currentGrade ? currentGrade.order_of_appearance : 0;

      // Filtrer et trier les classes - ne garder que celles avec un ordre supérieur
      this.allClassrooms = [];
      this.schoolList
        .filter(grade => grade.order_of_appearance > currentOrderOfAppearance)
        .sort((a, b) => a.order_of_appearance - b.order_of_appearance)
        .forEach((grade) => {
          if (grade.classrooms && grade.classrooms.length > 0) {
            // Ajouter le nom du niveau à chaque classe pour l'affichage
            const classroomsWithGrade = grade.classrooms.map((classroom) => {
              // S'assurer que chaque classe a un numéro
              if (!classroom.number) {
                classroom.number = "";
              }

              return {
                ...classroom,
                gradeName: grade.name,
              };
            });

            this.allClassrooms = [...this.allClassrooms, ...classroomsWithGrade];
          }
        });

      // Vérifier si au moins une classe est disponible
      this.has_class = this.allClassrooms.length > 0;
    } catch (err) {
      console.error("Failed to get Grades with classrooms", err);
    } finally {
      this.loading = false;
    }
  },
  components: {
    ArgonButton,
    ClassDropdown,
  },
  methods: {
    getCurrentClassName() {
      // Find the current classroom name from the schoolList
      if (this.schoolList && this.schoolList.length > 0) {
        for (const grade of this.schoolList) {
          if (grade.classrooms && grade.classrooms.length > 0) {
            const classroom = grade.classrooms.find(c => c.id === this.classroomId);
            if (classroom) {
              return `${grade.name} ${classroom.number || ''}`;
            }
          }
        }
      }
      return 'classe actuelle';
    },

    getPromotedClassName() {
      // Get the promoted classroom name from selectedClassObj
      if (this.selectedClassObj) {
        return `${this.selectedClassObj.gradeName} ${this.selectedClassObj.number || ''}`;
      }
      return 'classe promue';
    },

    route() {
      const classId = this.selectedClass;
      if (!classId || classId === "default") {
        toast.error(this.$t("studentlist.label_select_class"));
        return;
      }
      this.$router
        .push({
          name: "class-details",
          params: { classId },
        })
        .then(() => {
          window.location.reload();
        });
    },

    selectClass(classroom) {
      this.selectedClass = classroom.id;
      this.selectedClassObj = classroom;
    },

    annuler() {
      this.$emit("cancel");
    },
    closeModal() {
      // Reset all state variables to prevent any visual glitches
      this.isConfirmed = false;
      this.selectedClass = "default";
      this.selectedClassObj = null;
      this.formSubmitted = false;
      this.loading = false;
      this.buttonActive = false;
      this.showConfirmation = false;
      
      // Emit cancel event and close modal
      this.$emit("cancel");
      
      // Reload page after a brief delay to ensure modal is fully closed
      setTimeout(() => {
        window.location.reload();
      }, 150);
    },

    async checkConnection() {
      try {
        await Promise.all([getGrades()]);
        this.apiError = false;
      } catch (error) {
        console.error("API Error:", error);
        this.apiError = true;
      }
    },
    async getData() {
      let grades = await getGrades();
      this.GRADE_CODE = grades.data;
      this.grade_code = "";
      this.grade_name = "";
      let specialities = await getSpeciality();
      this.SPECIALITY_CODE = specialities.data;
      this.speciality = "";
    },

    async PromoteStudent() {
      if (this.loading) {
        return;
      }
      this.formSubmitted = true;

      // Vérifier si une classe est sélectionnée
      if (this.selectedClass === "default") {
        return;
      }

      this.loading = true;

      try {
        let data = {
          action: this.promote,
          current_classroom_id: this.classroomId,
          new_classroom_id: this.selectedClass,
          registration_number_list: this.registrationNumbers,
        };

        let response = await PromoteStudent(data);

        if (response && response.status === 404) {
          toast.error(this.$t("message.user404"), { autoClose: 3000 });
        } else if (response && response.status === 403) {
          toast.error(this.$t("new_class.impossible_add_class"), {
            autoClose: 3000,
          });
        } else {
          // Store the selected class info before changing state
          const promotedClassInfo = {
            id: this.selectedClass,
            name: this.getPromotedClassName()
          };
          
          this.isConfirmed = true;
          this.$emit("promotion-success");
          
          // Ensure the selected class info is preserved
          this.selectedClassObj = this.allClassrooms.find(c => c.id === promotedClassInfo.id);
        }
      } catch (error) {
        console.error(
          "Erreur lors de la création de la salle de classe :",
          error
        );
      } finally {
        this.loading = false;
        this.buttonActive = false;
      }
    },
  },
};
</script>

<style scoped>
#span-number {
  height: 25px;
  width: 20px;
}
#select-class {
  height: 45px;
}

.directions {
  display: flex;
  width: max-content;
  gap: 15px;
}
</style>
